export default "__VITE_ASSET__Cx3duHnW__"